import React, { useState } from 'react';
import {
	ModalContextProvider,
	useModalContext,
} from '../../Modules/Modal/Services/ModalContext';
import { joinClasses } from '../../Utils/className.util';
// @ts-ignore
import styles from './Modal.module.scss';
import { Size } from '../../Enums/Size.enum';
import ModalCloseConfirmation from '../../Modules/Modal/Components/ModalCloseConfirmation';

interface Props {
	isOpen: boolean;
	wrapChat: boolean;
	fullScreen: boolean;
	size: Size;
	children: React.ReactChild | React.ReactChild[];
	onClose: () => void;
	forceClose?: boolean;
	closeButton?: JSX.Element;
	style?: React.CSSProperties;
}

const ModalWrapper: React.FC<Props> = props => {
	const { isOpen, forceClose = false } = props;

	if (!isOpen) {
		return <></>;
	}

	return (
		<ModalContextProvider>
			<ModalContent {...props} />
		</ModalContextProvider>
	);
};

const ModalContent: React.FC<Props> = props => {
	const {
		wrapChat,
		fullScreen,
		size,
		children,
		onClose,
		forceClose = false,
		style,
	} = props;
	const modalContext = useModalContext();
	const [isCloseConfirmationOpen, setIsCloseConfirmationOpen] = useState(false);

	const handleClose = () => {
		onClose();
		modalContext?.onModalClose();
	};

	const handleCloseModal = () => {
		if (forceClose || modalContext?.checkIfModalCanBeClosed()) {
			onClose();
		} else {
			setIsCloseConfirmationOpen(true);
		}
	};

	return (
		<div
			className={joinClasses([styles.wrapper, wrapChat && styles.showChat])}
			style={style}>
			<div className={styles.backdrop} />
			<div
				className={joinClasses([
					styles.modal,
					fullScreen && styles.fullScreen,
					size && styles[size],
				])}>
				{React.Children.toArray(children)
					.filter(Boolean)
					.map((child: any) =>
						React.cloneElement(child, {
							onClose: () => handleCloseModal(),
						}),
					)}
			</div>
			{isCloseConfirmationOpen && (
				<ModalCloseConfirmation
					isOpen={isCloseConfirmationOpen}
					onReject={() => setIsCloseConfirmationOpen(false)}
					onConfirm={handleClose}
				/>
			)}
		</div>
	);
};

export default ModalWrapper;
